<template>
  <div>
    <div class="w-full flex bg-white border-tb-12px">
      <div class="bg-f4f5f6 pb-5 border-round w-full">
        <div class="w-full">
          <!-- <img
            :src="showImage(selectedextension.image)"
            class="object-cover ban-he w-full border-round"
            alt="banh"
          /> -->
          <img
            :src="showImage(selectedextension.bannerImage)"
            class="object-cover ban-he w-full border-round"
            alt="banh"
          />
        </div>
        <div class="pt-6">
          <div class="px-6">
            <div>
              <div class="flex justify-between w-full items-center">
                <h1 class="text-black font-semibold fsize20">
                  {{ selectedextension.name }}
                </h1>
                <h1 class="text-black font-semibold fsize20">
                  ₹{{ selectedextension.price }}
                </h1>
              </div>
              <p class="col-4f my-2">
                {{ selectedextension.description }}
              </p>
            </div>
            <!-- <div class="mt-8">
              <h4 class="fsize16 text-black font-semibold">How it works</h4>
              <div class="grid grid-cols-1 mt-4">
                <p class="col-4f fsize13 flex gap-2 mb-1 items-center">
                  <span class="greenh p-1"></span> Get a proffesional Buissness
                  card design to represent your band as
                </p>
                <p class="col-4f fsize13 flex gap-2 mb-1 items-center">
                  <span class="greenh p-1"></span> Get a proffesional Buissness
                  card design to represent your band as
                </p>
                <p class="col-4f fsize13 flex gap-2 mb-1 items-center">
                  <span class="greenh p-1"></span> Get a proffesional Buissness
                  card design to represent your band as
                </p>
              </div>
            </div> -->
          </div>
          <!-- <div class="mt-10 px-6">
            <p class="font-semibold third-fonts pb-3">Recent Design</p>

            <div class="grid grid-cols-4 gap-4 mt-3">
              <div>
                <img
                  src="@/assets/images/card1.png"
                  class="object-cover w-full h-32 border-round"
                  alt="banh"
                />
              </div>
              <div>
                <img
                  src="@/assets/images/card2.png"
                  class="object-cover w-full h-32 border-round"
                  alt="banh"
                />
              </div>
              <div>
                <img
                  src="@/assets/images/card3.png"
                  class="object-cover w-full h-32 border-round"
                  alt="banh"
                />
              </div>
              <div>
                <img
                  src="@/assets/images/card4.png"
                  class="object-cover w-full h-32 border-round"
                  alt="banh"
                />
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <!-- <div class="w-5/12 pl-12 rounded-lg">
        <AddonsPayment />
      </div> -->
    </div>
  </div>
</template>
<script>
// import AddonsPayment from "../components/AddonsPayment.vue";
import { mapState } from "vuex";
export default {
  components: {
    // AddonsPayment,
  },
  methods: {
    handleclick() {
      this.$router.push({ name: "studio-AddonsPayment" });
    },
    showImage(value) {
      let default_image = require("@/assets/images/card1.png");
      let image_base_url = process.env.VUE_APP_IMAGE_URL;

      return value ? `${image_base_url}${value}` : default_image;
    },
  },
  computed: {
    ...mapState("Extensions", ["extensions", "selectedextension"]),
  },
};
</script>
